import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
  OnDestroy
} from '@angular/core';

@Directive({
    selector: '[appInputStatesReflector]',
    standalone: false
})
export class InputStatesReflectorDirective implements AfterViewInit, OnDestroy {
  private readonly unbindFunctionList: (() => void)[] = [];

  @Input('appInputStatesReflector') inputElement: HTMLInputElement;

  @Input('classNames') private classNames = {
    focus: ['focused', 'unfocused']
  };

  public constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  public ngAfterViewInit(): void {
    this.bind();
  }

  public ngOnDestroy(): void {
    this.unbind();
  }

  private unbind() {
    /**
     * Unbind all the listeners after also clearing the list, just in case
     */
    for (const unbindFunction of this.unbindFunctionList.splice(
      0,
      this.unbindFunctionList.length
    )) {
      unbindFunction();
    }
  }

  private bind() {
    /**
     * Unbind existing listeners, if any
     */
    this.unbind();
    /**
     * Make sure `this.inputElement` is defined
     */
    if (!this.inputElement) {
      console.error(
        'No element provided to `appInputStatesReflector` directive'
      );
      return;
    }
    this.unbindFunctionList.push(
      this.renderer.listen(this.inputElement, 'focus', () => {
        this.setFocusState(true);
      })
    );
    this.unbindFunctionList.push(
      this.renderer.listen(this.inputElement, 'blur', () => {
        this.setFocusState(false);
      })
    );
  }

  private setFocusState(isFocused: boolean) {
    if (!this.elementRef) {
      console.error('No host for the directive');
      return;
    }
    const el = this.elementRef.nativeElement;
    if (isFocused) {
      this.renderer.removeClass(el, this.classNames.focus[1]);
      this.renderer.addClass(el, this.classNames.focus[0]);
    } else {
      this.renderer.removeClass(el, this.classNames.focus[0]);
      this.renderer.addClass(el, this.classNames.focus[1]);
    }
  }
}
